import React, { useState } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import Cookies from "js-cookie";
import { Table, TableContainer } from "../styles";
import UserSelect from "../UserSelect";
import RowCount from "../RowCount";
import MiscJsonCell from "../MiscJsonCell";
import {
  fetchFeedOwnerDetailRows,
  FeedOwnerDetailRow
} from "../../../actions/feedOwnerReportDetail";

const DETAILED_COLUMNS = [
  "user", "client_name", "country", "version", "feed_type",
  "feed_created_date", "feed_start_date", "feed_end_date",
  "paused", "feed_status", "has_brand_filter", "brand_filter_raw",
  "created_within_last_30_days", "last_progress_logical_date",
  "last_progress_activity_at", "delivery_integration", "misc_json"
] as const;

type Props = {
  users: string[];
  rows: FeedOwnerDetailRow[];
  selectedUser: string | null;
  fetchRows: (token: string, user: string) => void;
};

function FeedOwnerDetailed({ users, rows, selectedUser, fetchRows }: Props) {
  const [picked, setPicked] = useState<string | null>(selectedUser);

  const onPick = (user: string) => {
    setPicked(user);
    const token = Cookies.get("accessToken") || "";
    fetchRows(token, user);
  };

  return (
    <>
      <UserSelect users={users} selected={picked} onSelect={onPick} />
      {!picked && <p style={{ color: "#6b7280" }}>Pick a user to see their reports.</p>}
      {picked && (
        picked !== selectedUser
          ? <p style={{ color: "#6b7280" }}>Loading…</p>
          : rows.length === 0
            ? <p style={{ color: "#6b7280" }}>No reports for {picked}.</p>
            : (
              <>
                <TableContainer>
                  <Table>
                    <thead>
                      <tr>{DETAILED_COLUMNS.map(c => <th key={c}>{c}</th>)}</tr>
                    </thead>
                    <tbody>
                      {rows.map((row, i) => (
                        <tr key={i}>
                          {DETAILED_COLUMNS.map(c => (
                            <td key={c}>
                              {row[c] == null
                                ? ""
                                : (c === "misc_json" || typeof row[c] === "object")
                                  ? <MiscJsonCell value={row[c]} />
                                  : String(row[c])}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </TableContainer>
                <RowCount count={rows.length} user={picked} />
              </>
            )
      )}
    </>
  );
}

const mapStateToProps = (state: any) => ({
  users: state.entities.feedOwnerReportDetail.users,
  rows: state.entities.feedOwnerReportDetail.rows,
  selectedUser: state.entities.feedOwnerReportDetail.selectedUser
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchRows: (token: string, user: string) =>
    fetchFeedOwnerDetailRows(token, user)(dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedOwnerDetailed);
